
import React from 'react';
import * as SharedAcross from './Common/SharedAcross';
import GeogMap from './GeogMap';
import Youtube from './Youtube';

function App(props) {

  var height = props.height;
  var width = props.width;
  var html = props.html;
  var showPiece = props.showPiece;

  return doAHTML(html, 0, height, width);

function injestStyles(styles, origStyle){
  styles.map((aStyle, index)=>{
    var key = aStyle.v[0].v;
    var val = aStyle.v[1].v;
    origStyle[key] = val;
    return null;
  })
  return origStyle;
}

function doAHTML(aText, index, height, width){
    var type = aText.v[0].v;
    var contents;
    if (aText.v.length > 1){
     contents = aText.v[1].v;
    }
    if (type === "contents"){
      return showPiece;
    }else if (type === "b"){ //to remove
      var styles = [];
      if (aText.v.length > 2){
        styles = aText.v[2].v;
      }            
      return <div style={injestStyles(styles, {fontSize:"1.5em"})}><b>{contents}</b></div>
    }else if (type === "header"){
      var styles0 = injestStyles(aText.v[1].v, {fontSize:"1.5em"});
      var text = styles0.text;
      if (!text){
        text = "Header";
      }
      return <div style={styles0}><b>{text}</b></div>
    }else if (type === "dv"){
      var convertedText = contents.map((aText1, index1)=>{
        return doAHTML(aText1, index1, height, width);
      })
      var stylesX = {};
      if (aText.v.length > 2){
       stylesX = injestStyles(aText.v[2].v, {});
      }
      return <div style={stylesX}>{convertedText}</div>
//
    }else if (type === "d"){ //to remove
      if (contents.length > 0){
       var splitContents = contents.split("\n");
       var insides = splitContents.map((aSplit, index2)=>{
        if (aSplit.length === 0){
          return <div>&nbsp;</div>
        }
//
          var countNosTabs =  aSplit.split("\t").length - 1;
          return <div key={index2} style={{paddingLeft:countNosTabs*10}}>{aSplit}</div>
        })
//             
      var styles1 = [];
      if (aText.v.length > 2){
        styles1 = aText.v[2].v;
      }
      return <div style={injestStyles(styles1, {})}>{insides}</div>
//              
      }else{
        return null;
      }
    }else if (type === "textBox"){ 
      var styles00 = injestStyles(aText.v[1].v, {});
      contents = styles00.text;
      if (!contents){
        contents = "Hello";
      }
      if (contents){
        if (contents.length > 0){
         insides = contents.split("\n").map((aSplit, index2)=>{
            return <div key={index2}>{aSplit}</div>
          })
        }        
      }
//
      return <div style={styles00}>{insides}</div>
//
    }else if (type === "link"){//to remove
      return <button className="linkButton" onClick={SharedAcross.openUrl(aText.v[2].v)} >{contents}</button>
//
    }else if (type === "hyperlink"){
      var styles20 = injestStyles(aText.v[1].v, {padding:"10px"})
      var link = styles20.url;

      if (!link){
        link = "https://www.google.com";
      }

      var linkText = styles20.text;
      if (!linkText){
        linkText = "click here";
      }

      return <button className="linkButton" onClick={SharedAcross.openUrl(link)} >{linkText}</button>
//          
    }else if (type === "break"){
      return <div><br/></div>
//          
    }else if (type === "image"){ //to remove
      var styles2 = [];
      if (aText.v.length > 2){
        styles2 = aText.v[2].v;
      }

      return <img alt="" style={injestStyles(styles2, {padding:"10px"})} src={contents} width="80%"/>
//
    }else if (type === "img"){
      var styles200 = injestStyles(aText.v[1].v, {padding:"10px"})
      var src = styles200.src;
      if (!src){
        src = "/client_pictures/trophy.png";
      }

      return <img alt="" style={styles200} src={src} width="80%"/>
//            
    }else if (type === "youtube"){ //toremove

      return <Youtube contents={contents} height={height} />

    }else if (type === "youtubeVideo"){
      var styles2000 = injestStyles(aText.v[1].v, {});
      return <Youtube contents={styles2000.url} height={height} />
//            
    }else if (type === "translateQnAnswers"){

      var rows5 = contents.map((aContent,index4)=>{
        return <tr key={index4}><td><b>{aContent.v[0].v}</b><br/>{aContent.v[1].v}</td></tr>
      })
      return <table><tbody>{rows5}</tbody></table>
//
    }else if (type === "table"){
      var headers = aText.v[1].v;
      var headerRow = headers.map((aHeader, index3)=>{
        return <td key={index3}><b>{aHeader.v}</b></td>
      })
//            
      var rowsInfo = aText.v[2].v;
      var rows = rowsInfo.map((aRow, index3)=>{
        var cells = aRow.v.map((aCell, index4)=>{
          var inside = "";
          if (aCell.t === "number"){
            inside = aCell.v;
          }else if (aCell.t === "binary"){
            inside = aCell.v;
          }else if (aCell.t === "tuple"){
            if (aCell.v[0].v === "date"){
              inside = aCell.v[1].v[2].v + "-" + aCell.v[1].v[1].v + "-" + aCell.v[1].v[0].v;
            }
          }else{
            console.log(aCell);
          }
          return <td>{inside}</td>
        })
//
        return <tr key={index3}>{cells}</tr>
      })
//
      return <table><tbody><tr key="h">{headerRow}</tr>{rows}</tbody></table>
//
    }else if (type === "map"){//to remove
      var points = contents.map((aLocation, index)=>{
        return {lat:aLocation.v[0].v, long:aLocation.v[1].v, name:aLocation.v[2].v, details:aLocation.v[3].v};
      })
      return <GeogMap points={points} width={width} />
    }else if (type === "geog"){
      var styles7000 = injestStyles(aText.v[1].v, {});
      var points0 = styles7000.location.map((aLocation, index)=>{
        return {lat:aLocation.v[0].v, long:aLocation.v[1].v, name:aLocation.v[2].v, details:aLocation.v[3].v};
      })
      return <GeogMap points={points0} width={width} />
   
    }
    return null;

  }
}

export default App;
